import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

function StudentJoin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    studentId: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const sessionId = searchParams.get('session');

  useEffect(() => {
    // Check if user is already registered
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        // If user has valid session, redirect to danmu page
        if (user.sessionId && user.sessionId === sessionId) {
          navigate('/danmu');
          return;
        }
      } catch (e) {
        // Invalid stored data, clear it
        localStorage.removeItem('user');
      }
    }

    // Validate session if sessionId exists
    if (sessionId) {
      axios.get(`/api/validate-session/${sessionId}`)
        .then(response => {
          if (!response.data.valid) {
            setError('无效的会话链接，请重新扫码加入');
          }
        })
        .catch(() => {
          setError('无法验证会话，请检查网络连接');
        });
    } else {
      setError('无效的会话链接，请重新扫码加入');
    }
  }, [sessionId, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.studentId) {
      setError('请填写完整信息');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post('/api/register', {
        ...formData,
        sessionId
      });

      if (response.data.success) {
        const user = {
          id: response.data.userId,
          name: formData.name,
          studentId: formData.studentId,
          sessionId: sessionId
        };
        localStorage.setItem('user', JSON.stringify(user));
        
        // 显示成功消息
        if (response.data.message) {
          setSuccessMessage(response.data.message);
          setTimeout(() => {
            navigate('/danmu');
          }, 1500); // 1.5秒后跳转
        } else {
          navigate('/danmu');
        }
      }
    } catch (error) {
      console.error('Registration error:', error);
      if (error.response && error.response.data && error.response.data.error) {
        setError(error.response.data.error);
      } else {
        setError('注册失败，请检查网络连接并重试');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
    setSuccessMessage('');
  };

  // Quick join for returning users
  const handleQuickJoin = () => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      navigate('/danmu');
    }
  };

  if (!sessionId) {
    const storedUser = localStorage.getItem('user');
    return (
      <div className="container">
        <div className="error-message">
          无效的会话链接，请重新扫码加入
        </div>
        {storedUser && (
          <div style={{marginTop: '20px', textAlign: 'center'}}>
            <p style={{marginBottom: '10px'}}>您之前已经加入过弹幕系统</p>
            <button onClick={handleQuickJoin} className="btn">
              直接进入弹幕页面
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="container">
      <h1>加入弹幕系统</h1>
      <p>欢迎加入课堂弹幕系统！请填写您的信息：</p>

      {error && <div className="error-message">{error}</div>}
      {successMessage && <div className="success-message" style={{
        color: '#28a745',
        background: '#d4edda',
        border: '1px solid #c3e6cb',
        padding: '10px',
        borderRadius: '4px',
        marginBottom: '15px'
      }}>{successMessage}</div>}

      <form onSubmit={handleSubmit} className="form-container">
        <div className="form-group">
          <label>姓名:</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="请输入您的姓名"
            required
          />
        </div>

        <div className="form-group">
          <label>学号:</label>
          <input
            type="text"
            name="studentId"
            value={formData.studentId}
            onChange={handleChange}
            placeholder="请输入您的学号"
            required
          />
        </div>

        <button 
          type="submit" 
          className="btn" 
          disabled={loading}
        >
          {loading ? '加入中...' : '加入课堂'}
        </button>
      </form>

      <div style={{marginTop: '20px', fontSize: '14px', color: '#666'}}>
        <p>注意：您的弹幕将以匿名方式显示，但教师可以查看发送者身份</p>
      </div>

      {localStorage.getItem('user') && (
        <div style={{marginTop: '20px', textAlign: 'center', borderTop: '1px solid #ddd', paddingTop: '20px'}}>
          <p style={{marginBottom: '10px', color: '#666'}}>已经注册过？</p>
          <button onClick={handleQuickJoin} className="btn" style={{background: '#9C27B0'}}>
            直接进入弹幕页面
          </button>
        </div>
      )}
    </div>
  );
}

export default StudentJoin;